export function normalizeText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9ñ\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

interface ConceptGroup {
  label: string
  variants: string[]
}

export function parseConceptGroups(keywords: string[]): ConceptGroup[] {
  return keywords
    .map((entry) => entry.split('|').map((item) => item.trim()).filter(Boolean))
    .filter((variants) => variants.length > 0)
    .map((variants) => ({ label: variants[0]!, variants }))
}

export function detectKeywords(answer: string, keywords: string[]): {
  detected: string[]
  missing: string[]
} {
  const normalizedAnswer = normalizeText(answer)
  const groups = parseConceptGroups(keywords)
  const detected = groups
    .filter((group) => group.variants.some((variant) => normalizedAnswer.includes(normalizeText(variant))))
    .map((group) => group.label)
  const missing = groups.filter((group) => !detected.includes(group.label)).map((group) => group.label)
  return { detected, missing }
}
